// Auth API tags
export const AUTH_API_TAGS = {
  AUTH: "auth",
} as const;

export const EMPLOYEE_API_TAGS = {
  EMPLOYEE: "employee",
} as const;

// User roles
export const USER_ROLES = {
  ADMIN: "admin",
} as const;

// API tags & role types
export type TAuthApiTags = (typeof AUTH_API_TAGS)[keyof typeof AUTH_API_TAGS];
export type TUserRoles = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export const COURSE_API_TAGS = {
  CATEGORIES: "categories",
  SUBCATEGORIES: "sub_categories",
  COURSES: "courses",
  COURSES_ALLOW_USERS: "courses_allow_users",
  COURSES_HIGHLIGHTS: "course_highlights",
  TAGS: "tags",
  COURSES_TAGS: "course_tags",
  SECTIONS: "sections",
  LECTURES: "lectures",
  QUIZZES: "quizzes",
  QUESTIONS: "questions",
  OPTIONS: "options",
  ORDERS: "orders",
  PROMOTIONS: "promotions",
} as const;
export type TCourseApiTags =
  (typeof COURSE_API_TAGS)[keyof typeof COURSE_API_TAGS];

export const BN_MAP: Record<string, string> = {
  অ: "o",
  আ: "a",
  ই: "i",
  ঈ: "i",
  উ: "u",
  ঊ: "u",
  এ: "e",
  ঐ: "oi",
  ও: "o",
  ঔ: "ou",
  ক: "k",
  খ: "kh",
  গ: "g",
  ঘ: "gh",
  চ: "ch",
  ছ: "ch",
  জ: "j",
  ঝ: "jh",
  ট: "t",
  ঠ: "th",
  ড: "d",
  ঢ: "dh",
  ত: "t",
  থ: "th",
  দ: "d",
  ধ: "dh",
  ন: "n",
  প: "p",
  ফ: "f",
  ব: "b",
  ভ: "bh",
  ম: "m",
  য: "j",
  র: "r",
  ল: "l",
  শ: "sh",
  স: "s",
  হ: "h",
};
